import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'reducers/stateTypes';

export const selectIsUsedInBr = createSelector(
  (state: GlobalState) => state.contactNoteList,
  (noteList) => noteList.usedInBr,
);
